<div [class]="value ? 'succeed' : 'failed'"></div>